import { render, staticRenderFns } from "./RptPeerReview.vue?vue&type=template&id=06ccf146&scoped=true&"
import script from "./RptPeerReview.vue?vue&type=script&lang=js&"
export * from "./RptPeerReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ccf146",
  null
  
)

export default component.exports